import { date, showAlert } from '@/lib/helpers';
import { headers, search } from './attributes';

export default {
  data() {
    return {
      options: {},
      headers,
      search,
      filterValue: {},
      filterType: [],
      dialog: false,
      isEdit: false,
      editedIndex: -1,
      editedItem: {
        id: null,
        kode_wilayah: '',
        sandi_cabang: '',
        branch_code_bcko: '',
        kode_cabang: '',
        outlet_status: '',
        outlet_name: '',
      },
      defaultItem: {
        id: null,
        kode_wilayah: '',
        sandi_cabang: '',
        branch_code_bcko: '',
        kode_cabang: '',
        outlet_status: '',
        outlet_name: '',
      },
      formLoading: false,
      formErrors: {},
    };
  },
  computed: {
    filterData() {
      return [
        { label: 'Wilayah', field: 'kode_wilayah', type: 'text' },
        { label: 'Sandi Cabang', field: 'sandi_cabang', type: 'text' },
        { label: 'Branch Code', field: 'branch_code_bcko', type: 'text' },
        { label: 'Kode Cabang', field: 'kode_cabang', type: 'text' },
        { label: 'Status Outlet', field: 'outlet_status', type: 'text' },
        { label: 'Nama Outlet', field: 'outlet_name', type: 'text' },
        { label: 'Create Date', field: 'created_at', type: 'date' },
        { label: 'Last Update', field: 'updated_at', type: 'date' },
      ];
    },
    allData() {
      return this.$store.state.bcko.allData;
    },
    totalData() {
      return this.$store.state.bcko.totalData;
    },
    totalPage() {
      return this.$store.state.bcko.totalPage;
    },
    loading() {
      return this.$store.state.bcko.loading;
    },
    dialogTitle() {
      return this.isEdit ? 'Edit BC / KO' : 'Add BC / KO';
    },
    formFields() {
      return [
        {
          key: 'kode_wilayah',
          label: 'Wilayah',
          type: 'text',
          cols: 6,
          maxLength: 2,
          inputType: 'number',
          rules: [
            v => !!v || 'Wilayah is required',
            v => /^\d+$/.test(v) || 'Wilayah harus berupa angka',
            v => (v && v.length <= 2) || 'Wilayah maksimal 2 digit',
          ],
        },
        {
          key: 'sandi_cabang',
          label: 'Sandi Cabang',
          type: 'text',
          cols: 6,
          maxLength: 3,
          inputType: 'number',
          rules: [
            v => !!v || 'Sandi Cabang is required',
            v => /^\d+$/.test(v) || 'Sandi Cabang harus berupa angka',
            v => (v && v.length <= 3) || 'Sandi Cabang maksimal 3 digit',
          ],
        },
        {
          key: 'branch_code_bcko',
          label: 'Branch Code BC/KO',
          type: 'text',
          cols: 6,
          maxLength: 8,
          inputType: 'number',
          rules: [
            v => !!v || 'Branch Code BC/KO is required',
            v => /^\d+$/.test(v) || 'Branch Code BC/KO harus berupa angka',
            v => (v && v.length === 8) || 'Branch Code BC/KO harus 8 digit',
          ],
        },
        {
          key: 'kode_cabang',
          label: 'Kode Cabang',
          type: 'text',
          cols: 6,
          maxLength: 3,
          uppercase: true,
          rules: [
            v => !!v || 'Kode Cabang is required',
            v => /^[A-Z]+$/.test(v) || 'Kode Cabang harus berupa huruf (A-Z)',
            v => (v && v.length <= 3) || 'Kode Cabang maksimal 3 huruf',
          ],
        },
        {
          key: 'outlet_status',
          label: 'Status Outlet',
          type: 'text',
          cols: 6,
          maxLength: 25,
          uppercase: true,
          rules: [
            v => !!v || 'Status Outlet is required',
            v => (v && v.length <= 25) || 'Status Outlet maksimal 25 karakter',
          ],
        },
        {
          key: 'outlet_name',
          label: 'Nama Outlet',
          type: 'text',
          cols: 6,
          maxLength: 100,
          uppercase: true,
          rules: [
            v => !!v || 'Nama Outlet is required',
            v => (v && v.length <= 100) || 'Nama Outlet maksimal 100 karakter',
          ],
        },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    getData() {
      const { page = 1, itemsPerPage = 10 } = this.options;

      this.$store
        .dispatch('bcko/getData', {
          date,
          page,
          itemsPerPage,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            this.options.page = this.totalPage === 0 ? 1 : this.totalPage;
          }
        });
    },
    openAddDialog() {
      this.isEdit = false;
      this.editedIndex = -1;
      this.editedItem = { ...this.defaultItem };
      this.dialog = true;
    },
    openEditDialog(item) {
      this.isEdit = true;
      this.editedIndex = this.allData.indexOf(item);
      this.editedItem = {
        id: item.id,
        kode_wilayah: item.kode_wilayah,
        sandi_cabang: item.sandi_cabang,
        branch_code_bcko: item.branch_code_bcko,
        kode_cabang: item.kode_cabang,
        outlet_status: item.outlet_status,
        outlet_name: item.outlet_name,
      };
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.formErrors = {};
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.isEdit = false;
      });
    },
    async saveItem(formData) {
      this.formLoading = true;
      this.formErrors = {};

      try {
        let response;
        if (this.isEdit) {
          response = await this.$store.dispatch('bcko/updateData', {
            date,
            formData: {
              ...formData,
              id: this.editedItem.id,
            },
          });
        } else {
          response = await this.$store.dispatch('bcko/createData', {
            date,
            formData,
          });
        }

        if (response?.code === 200) {
          showAlert(
            this.$store,
            this.isEdit ? 'Data berhasil diupdate!' : 'Data berhasil ditambahkan!',
            'mdi-check-circle',
            'green'
          );
          this.closeDialog();
          this.getData();
        } else {
          this.handleFieldErrors(response?.data);
          const errorMessage = this.extractErrorMessage(response, 'Terjadi kesalahan!');
          showAlert(
            this.$store,
            errorMessage,
            'mdi-alert',
            'red'
          );
        }
      } catch (error) {
        showAlert(this.$store, 'Terjadi kesalahan!', 'mdi-alert', 'red');
      } finally {
        this.formLoading = false;
      }
    },
    handleFieldErrors(responseData) {
      if (!responseData) return;
      
      if (typeof responseData === 'object' && responseData !== null && !Array.isArray(responseData)) {
        this.formErrors = { ...responseData };
      }
    },
    extractErrorMessage(responseData, defaultMessage) {
      if (!responseData) return defaultMessage;
      
      const { data, message_en, message_id } = responseData;
      
      if (typeof data === 'string' && data.trim()) {
        return data;
      }
      
      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        const firstField = Object.keys(data)[0];
        if (firstField && Array.isArray(data[firstField]) && data[firstField].length > 0) {
          return data[firstField][0];
        }
      }
      
      return message_en || message_id || defaultMessage;
    },
    clearSearch() {
      this.search.kode_wilayah = '';
      this.search.sandi_cabang = '';
      this.search.branch_code_bcko = '';
      this.search.kode_cabang = '';
      this.search.outlet_status = '';
      this.search.outlet_name = '';
      this.search.created_at = '';
      this.search.updated_at = '';
    },
    updateSearch() {
      this.getData();
    },
    showType() {
      this.getData();
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};
